import { createContext } from "react";
export const ValidityStateContext = /*#__PURE__*/createContext();
export const SmallContext = /*#__PURE__*/createContext();
export const RangeInputContext = /*#__PURE__*/createContext();
export const IdContext = /*#__PURE__*/createContext();
export const DescribedByContext = /*#__PURE__*/createContext();
export const TypeContext = /*#__PURE__*/createContext();
export const DisabledContext = /*#__PURE__*/createContext();